import reduxStore from 'redux/store'
import {clearSignature, setSignature} from "../redux/actions";

export default () => {

    const doSignDocContent = (signatureTypes, docContentFunc, successCallback, errorCallback, cancelCallback, getEncryptionRoundId, makeTaskListConfig) => {
        reduxStore.dispatch(setSignature("config", {
            signatureTypes,
            docContentFunc,
            successCallback,
            errorCallback,
            cancelCallback,
            getEncryptionRoundId,
            makeTaskListConfig
        }))
    }

    const breakSigning = () => {
        reduxStore.dispatch(clearSignature("config"));
    }

    return {doSignDocContent, breakSigning};
}

